import { useTranslation } from "react-i18next";
import { Button, Input, Select } from "../UI";
import styled, { useTheme } from "styled-components";
import { observer, inject } from "mobx-react";
import Modal from "../UI/Modal";
import { useEffect, useState } from "react";
import { toBase64, isAcceptedFormat } from "../utils/helper";
import { useInput } from "../utils/hooks";
import { ClipLoader } from "react-spinners";
import ExtentionInsert from "../components/ExtentionInsert";
import ExtentionPreview from "../components/ExtentionPreview";

const Error = styled("div")`
  margin-top: 1rem;
  color: red;
`;

const UpdateMonthReport = ({
  monthReportsStore,
  userStore,
  period,
  gl,
  selectedReport,
  onSave,
  onClose,
}) => {
  const { t } = useTranslation("month_reports");
  const theme = useTheme();

  const accept = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
  const [isLoading, setLoading] = useState(false);
  const [isSaving, setSaving] = useState(false);
  const [report, setReport] = useState({ ...selectedReport });
  const [abs, setAbs] = useState([]);
  const [absType, setAbsType] = useState(
    selectedReport?.CODE
      ? { value: selectedReport.CODE, label: selectedReport.DES }
      : null
  );
  const [error, setError] = useState("");

  const vacInput = useInput({
    placeholder: t("vacation"),
    type: "number",
    value: report?.VAC || "",
  });

  const servInput = useInput({
    placeholder: t("service"),
    type: "number",
    value: report?.SERV || "",
  });
  const illInput = useInput({
    placeholder: t("illnace"),
    type: "number",
    value: report?.ILL || "",
  });

  const absInput = useInput({
    value: absType,
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      monthReportsStore.setError("");

      const absArray = await monthReportsStore.getAbs();
      const abs = absArray.map((a) => ({
        value: a.CODE,
        label: a.DES,
      }));
      if (!monthReportsStore.isError) {
        setAbs(abs);
      }
      setLoading(false);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleILLChange = (e) => {
    setReport({ ...report, ILL: e.target.value || 0 });
  };
  const handleVACChange = (e) => {
    setReport({ ...report, VAC: e.target.value || 0 });
  };
  const handleSERVChange = (e) => {
    setReport({ ...report, SERV: e.target.value || 0 });
  };

  const handleAbsChange = (value) => {
    setAbsType(value);
    setReport({ ...report, CODE: value?.value });
  };

  const handelUpdate = async () => {
    if (isSaving) return;

    monthReportsStore.setError("");

    const data = {
      ...report,
      ILL: parseFloat(report.ILL),
      VAC: parseFloat(report.VAC),
      SERV: parseFloat(report.SERV),
      CODE: !report?.CODE ? " " : report?.CODE,
    };

    const body = {
      CURDATE: data?.CURDATE,
      PERIOD: period,
      GL: gl,
      ZCR_USERID: userStore.userDetails.ZCR_USERB,
      data: data,
    };
    setSaving(true);
    await onSave(body);
    setSaving(false);
    if (!!monthReportsStore.error) {
      setError(monthReportsStore.error);
    } else {
      onClose();
    }
  };

  const handleSelectedFile = async (e) => {
    e.preventDefault();
    const files = e.target.files;
    isAcceptedFormat(files[0], accept);

    if (!isAcceptedFormat(files[0], accept)) {
      setError(t("error:format_file_type_not_allowed"));
      return;
    }

    if (files.length > 1) {
      setError("error:error_failed_upload_file");
      return;
    }

    try {
      const base64 = await toBase64(files[0]);
      const extentions = [];
      extentions.push({
        EXTFILEDES: files[0].name,
        EXTFILENAME: base64,
      });
      setReport({ ...report, EXTFILENAME: extentions.EXTFILENAME, extentions });
    } catch (err) {
      setError(t("error:error_failed_upload_file"));
    }
  };

  const removeSelectedFile = () => {
    const rep = report;
    delete rep["EXTFILENAME"];
    delete rep["extentions"];
    setReport({ ...rep });
  };

  // const onDragAndDrop = async (files) => {
  //   if (files?.length) {
  //     const accepted = [...files].map((file) => {
  //       return accept?.some((format) => {
  //         return file.name
  //           .toLowerCase()
  //           .endsWith(format.substring(format.indexOf("/") + 1).toLowerCase());
  //       });
  //     });

  //     if (accepted.includes(false)) {
  //       setError(t("error:format_file_type_not_allowed"));
  //       return;
  //     }

  //     try {
  //       const base64 = await toBase64(files[0]);

  //       setReport({
  //         ...report,
  //         EXTFILENAME: base64,
  //         EXTFILEDES: files[0].name,
  //       });
  //     } catch (err) {
  //       setError(t("error:error_failed_upload_file"));
  //     }
  //   } else {
  //     setError(t("error:error_failed_upload_file"));
  //   }
  // };

  return (
    <Modal onClose={() => onClose(false)} title={t("update_report_title")}>
      <div
        style={{
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}>
        {isLoading && (
          <div>
            <ClipLoader color={theme.color.label} />
          </div>
        )}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginBottom: "1rem",
            gap: 12,
          }}>
          <Input
            style={{ textAlign: "start" }}
            {...vacInput}
            onWheel={(e) => e.target.blur()}
            onBlur={(e) => handleVACChange(e)}
          />
          <Input
            style={{ textAlign: "start" }}
            {...illInput}
            onWheel={(e) => e.target.blur()}
            onBlur={(e) => handleILLChange(e)}
          />
          <Input
            style={{ textAlign: "start" }}
            {...servInput}
            onWheel={(e) => e.target.blur()}
            onBlur={(e) => handleSERVChange(e)}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}>
          <Select
            {...absInput}
            onChange={(e) => handleAbsChange(e)}
            options={abs}
            placeholder={t("choose_abs")}></Select>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: 10,
          }}>
          <ExtentionInsert
            singleFile={true}
            isWeb={true}
            extentions={report.extentions}
            onAdd={handleSelectedFile}
          />
          {report.extentions && (
            <ExtentionPreview
              onRemove={removeSelectedFile}
              files={report.extentions}
            />
          )}
        </div>
        {!!error && <Error> {t(error)} </Error>}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            onClick={handelUpdate}
            buttonStyle="main"
            style={{ marginTop: 30 }}>
            {isSaving && (
              <div>
                <ClipLoader color={theme.color.label} />
              </div>
            )}
            {t("update_report")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default inject(
  "monthReportsStore",
  "userStore"
)(observer(UpdateMonthReport));
